import "./Footer.style.css"

const Footer = () => {
    return (
        <footer>
            <p>© {new Date().getFullYear()} PT Irwan Sukses Abadi. All rights reserved.</p>
        </footer>
    )
}

export default Footer